import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'SIDEBAR.DASHBOARD',
        icon: 'ph-gauge',
        link: '/',
    },
    {
        id: 180,
        label: 'SIDEBAR.RUTA',
        icon: 'ph-map-trifold',
        link: '/ruta',
        roles: ['admin', 'super_admin', 'cobrador_ruta'],
        permiso: 'prestamos.ver',
    },
    {
        id: 220,
        label: 'SIDEBAR.PRESTAMOS.LABEL',
        icon: 'ph-handshake',
        roles: ['admin', 'super_admin'],
        subItems: [
            {
                id: 221,
                label: 'SIDEBAR.PRESTAMOS.VER',
                link: '/prestamos',
                parentId: 220,
                permiso: 'prestamos.ver',
            },
            {
                id: 222,
                label: 'SIDEBAR.PRESTAMOS.CREAR',
                link: '/prestamos/crear',
                parentId: 220,
                permiso: 'prestamos.gestionar',
            },
            {
                id: 223,
                label: 'SIDEBAR.PRESTAMOS.SOLICITUDES',
                link: '/prestamos/solicitudes',
                parentId: 220,
                permiso: 'prestamos.gestionar',
            }
        ]
    },
    {
        id: 190,
        label: 'SIDEBAR.CLIENTES.LABEL',
        icon: 'ph-users',
        roles: ['admin', 'super_admin'],
        subItems: [
            {
                id: 191,
                label: 'SIDEBAR.CLIENTES.VER',
                link: '/clientes',
                parentId: 190,
                permiso: 'clientes.ver',
            },
            {
                id: 192,
                label: 'SIDEBAR.CLIENTES.AGREGAR',
                link: '/clientes/agregar',
                parentId: 190,
                permiso: 'clientes.gestionar',
            }
        ]
    },
    {
        id: 210,
        label: 'SIDEBAR.CAJAS',
        icon: 'ph-vault',
        link: '/cajas',
        roles: ['admin', 'super_admin'],
        permiso: 'cajas.ver',
    },
    {
        id: 215,
        label: 'SIDEBAR.GASTOS',
        icon: 'ph-money',
        link: '/gastos',
        roles: ['admin', 'super_admin'],
        permiso: 'cajas.ver',
    },
    {
        id: 200,
        label: 'SIDEBAR.EQUIPO.LABEL',
        icon: 'ph-users-three',
        roles: ['admin', 'super_admin'],
        subItems: [
            {
                id: 201,
                label: 'SIDEBAR.EQUIPO.VER',
                link: '/equipo',
                parentId: 200,
                permiso: 'equipo.gestionar',
            },
            {
                id: 202,
                label: 'SIDEBAR.EQUIPO.AGREGAR',
                link: '/equipo/agregar',
                parentId: 200,
                permiso: 'equipo.gestionar',
            }
        ]
    },
    {
        id: 240,
        label: 'SIDEBAR.REPORTES',
        icon: 'ph-chart-bar',
        link: '/reportes',
        roles: ['admin', 'super_admin'],
        permiso: 'facturacion.ver',
    },
    {
        id: 250,
        label: 'SIDEBAR.FACTURACION',
        icon: 'ph-receipt',
        link: '/facturacion',
        roles: ['admin', 'super_admin'],
        permiso: 'facturacion.ver',
    },
    {
        id: 260,
        label: 'SIDEBAR.SOPORTE',
        icon: 'ph-lifebuoy',
        link: '/soporte',
        roles: ['admin', 'super_admin'],
        permiso: 'soporte.crear',
    },
    {
        id: 270,
        label: 'SIDEBAR.CHAT_EQUIPO',
        icon: 'ph-chat-circle-dots',
        link: '/chat',
        roles: ['admin', 'super_admin'],
        permiso: 'equipo.ver',
    },
    {
        id: 280,
        label: 'SIDEBAR.IMPORTAR_DATOS',
        icon: 'ph-upload-simple',
        link: '/importar',
        roles: ['admin'],
    },
    {
        id: 285,
        label: 'SIDEBAR.SOCIOS',
        icon: 'ph-share-network',
        link: '/socios',
        roles: ['admin', 'sub_admin', 'super_admin'],
    },
    {
        id: 230,
        label: 'SIDEBAR.CONFIGURACION.LABEL',
        icon: 'ph-gear-six',
        roles: ['admin', 'super_admin'],
        subItems: [
            {
                id: 231,
                label: 'SIDEBAR.CONFIGURACION.INTERESES',
                link: '/configuracion/intereses',
                parentId: 230,
                permiso: 'empresa.configurar',
            },
            {
                id: 232,
                label: 'SIDEBAR.CONFIGURACION.FRECUENCIAS',
                link: '/configuracion/frecuencias',
                parentId: 230,
                permiso: 'empresa.configurar',
            },
            {
                id: 233,
                label: 'SIDEBAR.CONFIGURACION.CATEGORIAS_GASTO',
                link: '/configuracion/categorias-gasto',
                parentId: 230,
                permiso: 'empresa.configurar',
            }
        ]
    }
]
